function getSessionStorageItem(key) {
  try {
    return globalThis.sessionStorage.getItem(key);
  } catch {
    return null;
  }
}
export {
  getSessionStorageItem
};
//# sourceMappingURL=get-session-storage-item.js.map
